import { render } from "./PostTimeContext.vue?vue&type=template&id=724660de&ts=true"
import script from "./PostTimeContext.vue?vue&type=script&lang=ts"
export * from "./PostTimeContext.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__